// @flow
import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import Layout from '../components/layout'
import GridElement from '../components/grid-element'
import WithSize from '../utils/with-size'

const getEdges = data => data.allMarkdownRemark.edges

const query = graphql`
  query MixesPageQuery {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { categories: { eq: "guest" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            path
            artist
            number
          }
        }
      }
    }
  }
`

const MixesPage = () => (
  <StaticQuery
    query={query}
    render={data => {
      const posts = getEdges(data)

      return (
        <Layout row centerContent>
          <WithSize>
            {({ small, medium }) =>
              posts.map(({ node }) => {
                const { frontmatter, id } = node
                return (
                  <GridElement type="gm" medium={medium} small={small} {...frontmatter} key={id} />
                )
              })
            }
          </WithSize>
        </Layout>
      )
    }}
  />
)

export default MixesPage
